import React from "react";

const STRENGTH_LABELS = ["", "Very Weak", "Weak", "Fair", "Strong", "Very Strong"];
const STRENGTH_COLORS = [
  "",
  "bg-red-500",
  "bg-orange-500",
  "bg-yellow-500",
  "bg-blue-500",
  "bg-green-500",
];
const STRENGTH_TEXT_COLORS = [
  "",
  "text-red-600",
  "text-orange-600",
  "text-yellow-600",
  "text-blue-600",
  "text-green-600",
];

const PasswordStrengthMeter = ({ strength }) => {
  const label = STRENGTH_LABELS?.[strength] || "";
  const textColor = STRENGTH_TEXT_COLORS?.[strength] || "";

  return (
    <div className="mt-2 space-y-1.5">
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5]?.map((level) => (
          <div
            key={level}
            className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${
              level <= strength ? STRENGTH_COLORS?.[strength] : "bg-gray-200"
            }`}
          />
        ))}
      </div>
      {label && (
        <p className={`text-xs font-medium ${textColor}`}>
          Password strength: {label}
        </p>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
